import { render, staticRenderFns } from "./AIBetaBadge.vue?vue&type=template&id=7678daf9&scoped=true"
import script from "./AIBetaBadge.vue?vue&type=script&lang=js"
export * from "./AIBetaBadge.vue?vue&type=script&lang=js"
import style0 from "./AIBetaBadge.vue?vue&type=style&index=0&id=7678daf9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678daf9",
  null
  
)

export default component.exports